import { useState } from "react";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "../ui/dialog";
import { Input } from "../ui/input";
import { Button } from "../ui/button";
import { errMsg } from "../../lib/api";
import { adminApi } from "../../lib/adminApi";

const EMPTY = { current_password: "", new_password: "", confirm: "" };

export const AdminPasswordDialog = () => {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (f.new_password.length < 6) return toast.error("La nuova password deve avere almeno 6 caratteri");
    if (f.new_password !== f.confirm) return toast.error("Le due password non coincidono");
    setBusy(true);
    try {
      await adminApi.post("/password", { current_password: f.current_password, new_password: f.new_password });
      toast.success("Password aggiornata");
      setF(EMPTY);
      setOpen(false);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button data-testid="admin-change-password-button" className="flex items-center gap-1.5 text-sm text-slate-300 hover:text-emerald-400"><KeyRound size={16} /> Cambia password</button>
      </DialogTrigger>
      <DialogContent className="bg-[#121824] border-[#26334D] text-white" data-testid="admin-password-dialog">
        <DialogHeader><DialogTitle className="font-display uppercase">Cambia password</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <Input type="password" placeholder="Password attuale" value={f.current_password} onChange={set("current_password")} required data-testid="admin-current-password-input" />
          <Input type="password" placeholder="Nuova password (min 6 caratteri)" value={f.new_password} onChange={set("new_password")} required data-testid="admin-new-password-input" />
          <Input type="password" placeholder="Ripeti nuova password" value={f.confirm} onChange={set("confirm")} required data-testid="admin-confirm-password-input" />
          <Button type="submit" disabled={busy} className="w-full rounded-full bg-emerald-500 hover:bg-emerald-400 text-[#0A0D14] font-bold" data-testid="admin-password-submit">{busy ? "Salvataggio…" : "Salva"}</Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
